var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassport2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C4.89543 2 4 2.90677 4 4.02532V19.9747C4 21.0932 4.89543 22 6 22H19C19.5523 22 20 21.5466 20 20.9873V5.79747C20 5.23819 19.5523 4.78481 19 4.78481H6.5C5.94772 4.78481 5.495 4.29062 5.85095 3.86834C6.02563 3.66112 6.2523 3.51899 6.5 3.51899H17.25C17.6642 3.51899 18 3.17895 18 2.75949C18 2.34004 17.6642 2 17.25 2H6ZM7.25 18C7.25 17.5858 7.58579 17.25 8 17.25H16C16.4142 17.25 16.75 17.5858 16.75 18C16.75 18.4142 16.4142 18.75 16 18.75H8C7.58579 18.75 7.25 18.4142 7.25 18ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport2);
export default __webpack_public_path__ + "static/media/passport-2.af1cff10585d1e04ebf1d080cf438cf7.svg";
export { ForwardRef as ReactComponent };